module.exports = __webpack_public_path__ + "img/concreted_asphalted_and_unstabilized.5aa62fa7.png";